import React from "react";
import { MultiSelect } from "primereact/multiselect";

const PoDetails = ({
  poData,
  error = {},
  firmData = [],
  partyData = [],
  projectData = [],
  stateList = [],
  cityList = [],
  handleChange,
  handlePartySelect,
  handleProjectSelect,
}) => {
  const projectOptions =
    projectData?.map((p) => ({
      label: p.project_no ? `${p.name} - ${p.project_no}` : p.name,
      value: p._id,
    })) || [];

  return (
    <div className="row">
      {/* Firm (Disabled, auto-selected from logged in firm, exactly like Quotation) */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            Firm <span className="login-danger">*</span>
          </label>
          <select
            className="form-select bg-light"
            value={poData.firm_id}
            disabled
            title="Firm is auto-selected"
          >
            <option value="">Select Firm</option>
            {firmData?.map((e) => (
              <option key={e._id} value={e._id}>
                {e.name}
              </option>
            ))}
          </select>
          {error.firm_id && (
            <small className="text-danger">{error.firm_id}</small>
          )}
        </div>
      </div>

      {/* Order Date */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            Order Date <span className="login-danger">*</span>
          </label>
          <input
            className={`form-control ${error.po_date ? "is-invalid" : ""}`}
            type="date"
            value={poData.po_date}
            onChange={(e) => handleChange(null, "po_date", e.target.value)}
          />
          {error.po_date && (
            <small className="text-danger">{error.po_date}</small>
          )}
        </div>
      </div>

      {/* Party / Vendor Name with Quick Datalist Selection */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            Party Name <span className="login-danger">*</span>
          </label>
          <input
            className={`form-control ${error.party_name ? "is-invalid" : ""}`}
            type="text"
            placeholder="Enter party name"
            value={poData.vendor_snapshot.name}
            onChange={(e) => {
              handleChange("vendor_snapshot", "name", e.target.value);
              const matched = partyData?.find(
                (p) =>
                  p.name?.toLowerCase().trim() === e.target.value?.toLowerCase().trim()
              );
              if (matched) {
                handlePartySelect(matched._id);
              }
            }}
            list="party-master-list"
          />
          <datalist id="party-master-list">
            {partyData?.map((p) => (
              <option key={p._id} value={p.name} />
            ))}
          </datalist>
          {error.party_name && (
            <small className="text-danger">{error.party_name}</small>
          )}
        </div>
      </div>


      {/* Contact Person */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>Contact Person</label>
          <input
            className="form-control"
            type="text"
            placeholder="Enter contact person name"
            value={poData.order_details.contact_person}
            onChange={(e) =>
              handleChange("order_details", "contact_person", e.target.value)
            }
          />
        </div>
      </div>

      {/* Site */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>Site</label>
          <input
            className="form-control"
            type="text"
            placeholder="Enter site name"
            value={poData.order_details.site}
            onChange={(e) =>
              handleChange("order_details", "site", e.target.value)
            }
          />
        </div>
      </div>

      {/* Projects MultiSelect */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms custom-select-wpr">
          <label>Projects</label>
          <MultiSelect
            value={poData.order_details.project_ids || []}
            onChange={(e) => handleProjectSelect(e.value || [])}
            options={projectOptions}
            optionLabel="label"
            optionValue="value"
            placeholder="Select Projects"
            filter
            className="w-100 multi-prime-react"
          />
        </div>
      </div>

      {/* GSTIN NO. */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>GSTIN NO.</label>
          <input
            className="form-control"
            type="text"
            placeholder="e.g. 23ABCDN8202K2ZV"
            value={poData.vendor_snapshot.gst_no}
            onChange={(e) =>
              handleChange(
                "vendor_snapshot",
                "gst_no",
                e.target.value.toUpperCase()
              )
            }
          />
        </div>
      </div>

      {/* Address */}
      <div className="col-12">
        <div className="input-block local-forms">
          <label>
            Address <span className="login-danger">*</span>
          </label>
          <textarea
            className={`form-control ${error.party_address ? "is-invalid" : ""}`}
            placeholder="Enter full address here..."
            rows={2}
            value={poData.vendor_snapshot.address_line1}
            onChange={(e) =>
              handleChange("vendor_snapshot", "address_line1", e.target.value)
            }
          />
          {error.party_address && (
            <small className="text-danger">{error.party_address}</small>
          )}
        </div>
      </div>

      {/* State Dropdown */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>
            State <span className="login-danger">*</span>
          </label>
          <select
            className={`form-select ${error.party_state ? "is-invalid" : ""}`}
            value={poData.vendor_snapshot.state}
            onChange={(e) =>
              handleChange("vendor_snapshot", "state", e.target.value)
            }
          >
            <option value="">Select State</option>
            {stateList?.map((state) => (
              <option key={state.isoCode} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>
          {error.party_state && (
            <small className="text-danger">{error.party_state}</small>
          )}
        </div>
      </div>

      {/* City Dropdown */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>City</label>
          <select
            className="form-select"
            value={poData.vendor_snapshot.city}
            onChange={(e) =>
              handleChange("vendor_snapshot", "city", e.target.value)
            }
          >
            <option value="">Select City</option>
            {cityList?.map((city) => (
              <option key={city.name} value={city.name}>
                {city.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Pincode */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>Pincode</label>
          <input
            className="form-control"
            type="number"
            placeholder="e.g. 362739"
            value={poData.vendor_snapshot.pincode}
            onChange={(e) =>
              handleChange("vendor_snapshot", "pincode", e.target.value)
            }
          />
        </div>
      </div>

      {/* Common Make */}
      <div className="col-12 col-md-6 col-xl-4">
        <div className="input-block local-forms">
          <label>Make</label>
          <input
            className="form-control"
            type="text"
            placeholder=""
            value={poData.common_make}
            onChange={(e) => handleChange(null, "common_make", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default PoDetails;
